import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM17.2394 9.56131C17.6201 9.18055 17.6201 8.56322 17.2394 8.18246C16.8586 7.80169 16.2413 7.80169 15.8605 8.18246L10.2937 13.7493L8.13939 11.595C7.75863 11.2142 7.14129 11.2142 6.76053 11.595C6.37977 11.9757 6.37977 12.5931 6.76053 12.9738L9.60428 15.8176C9.78713 16.0004 10.0351 16.1031 10.2937 16.1031C10.5523 16.1031 10.8003 16.0004 10.9831 15.8176L17.2394 9.56131Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgCheckCircleFilled);
export default ForwardRef;
